import * as React from "react";
import { Box, BoxProps, Flex, HStack, Text, VStack } from "@chakra-ui/react";
import { AccountArea } from "./AccountArea";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const SideNavHeader = ({
  pageTitle = "Publisher",
  children,
  ...rest
}: BoxProps & { pageTitle?: string, hideLogo?: boolean }) => {
  const location = useLocation();
  const [subtitle, setSubtitle] = useState("")

 
  useEffect(() => {
    
    if (location.pathname .includes("segments/new")) {
      setSubtitle("Create New Segment")
    } else if (location.pathname .includes("/review")) {
      setSubtitle("Review")
    } else if (location.pathname .includes("/past-review")) {
      setSubtitle("Correction")
    } else if (location.pathname .includes("/predictive-correction")) {
      setSubtitle("Predictions")
    } else {
      setSubtitle("")
    }
  }, [location.pathname])


  return (
    <Box mb={8} {...rest}>
      <HeaderRowContainer>
        <Flex justifyContent={"space-between"}>
          <VStack align="flex-start" mt={subtitle? "3" : "4"} ml={"2"}>
            <Text fontWeight={"medium"} color={"black"} fontSize={"20px"} h={5} >
              {pageTitle}
            </Text>
            {subtitle  &&(
            <Text color="muted" fontSize="12px">
            {subtitle}
          </Text>)
            }
            
          </VStack>
          <HStack>
            {/* CampaignSelectDisplay used to be here */}
            <AccountArea />
          </HStack>
        </Flex>
      </HeaderRowContainer>
      {children && <HeaderRowContainer>{children}</HeaderRowContainer>}
    </Box>
  );
};

const HeaderRowContainer: React.FC = ({ children }) => (
  <Box bg={"white"} px={[6, null, null, null, 6]}>
    <Box
        // maxW={"80rem"}
        mx={"auto"}
    >
      {children}
    </Box>
  </Box>
);